module.exports = __webpack_public_path__ + "static/media/flags_MYS.6915a572.svg";